import React from 'react';

const AppFooter = () => {

    return (
        <div className="layout-footer">
            <div className="footer-logo-container">
                {/*<img id="footer-logo" src="static/assets/layout/images/logo-dark.svg" alt="diamond-layout" />*/}
            </div>
            <span > &#169; Versiyon 2.0.0 - 2023</span>
        </div>
    );
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/AppFooter.js